import {
  ESTUDIOTURNOS_SUCCESS,
  ESTUDIOTURNOS_LOADING,
  ESTUDIOTURNOS_ERROR,
  ESTUDIOTURNOS_LOGOUT,
  ESTUDIOTURNOS_SETCIRCUITORESO,
  ESTUDIOTURNOS_SETCIRCUITOTOMO,
} from "../../ActionTypes";

import axiosLogin from "global/helpers/axiosLogin";

export const wsPostTurnosEstudiosQr =
  (requestBody, idPariente, nextStep) => (dispatch) => {
    dispatch({ type: ESTUDIOTURNOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .post(
          `his/estudios/turnos/${idPariente ? idPariente : -1}`,
          requestBody,
        )
        .then((resp) => {
          dispatch({
            type: ESTUDIOTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: ESTUDIOTURNOS_ERROR, payload: err?.data });
          if (nextStep) nextStep(false, err?.response?.data);
        });
    });
  };

export const wsGetVerificaEstudiosQr =
  (
    idGrupoMedico,
    particular,
    flgVideoAtencion,
    idPacFamiliar,
    osAlternativa,
    nextStep,
  ) =>
  (dispatch) => {
    dispatch({ type: ESTUDIOTURNOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/estudios/verificarOS/` +
            idGrupoMedico +
            `/` +
            particular +
            `/` +
            flgVideoAtencion +
            "/" +
            (idPacFamiliar ? idPacFamiliar : "-1") +
            "/" +
            (!osAlternativa ? "false" : osAlternativa),
        )
        .then((resp) => {
          dispatch({
            type: ESTUDIOTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          let error = {
            detail: err?.response?.data,
            mensaje: err?.response?.data
              ? // Si err.response.data es un objeto con 'detail', extraerlo
                typeof err?.response?.data === "object" &&
                err?.response?.data.detail
                ? err?.response?.data.detail
                : // Si es un objeto con 'title', usar title también
                  typeof err?.response?.data === "object" &&
                    err?.response?.data.title
                  ? err?.response?.data.title
                  : // Si es un objeto con 'mensaje', usar mensaje
                    typeof err?.response?.data === "object" &&
                      err?.response?.data.mensaje
                    ? err?.response?.data.mensaje
                    : // Si es un string, usarlo directamente
                      typeof err?.response?.data === "string"
                      ? err?.response?.data
                      : "Error al verificar obra social."
              : "Error al contactar el server.",
          };

          dispatch({ type: ESTUDIOTURNOS_ERROR, payload: error });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const wsPostTurnosKinesioQr = (requestBody, nextStep) => (dispatch) => {
  dispatch({ type: ESTUDIOTURNOS_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`his/estudios/turnosKin/${-1}`, requestBody)
      .then((resp) => {
        dispatch({
          type: ESTUDIOTURNOS_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: ESTUDIOTURNOS_ERROR, payload: err?.data });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const wsPostTomarTurnoKinesioQr = (requestBody) => (dispatch) => {
  dispatch({
    type: ESTUDIOTURNOS_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`his/estudios/tomarTurnoKin/${-1}`, requestBody)
      .then((res) => {
        dispatch({
          type: ESTUDIOTURNOS_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: ESTUDIOTURNOS_ERROR,
          payload: error,
        });
      });
  });
};

export const wsPostTomarTurnoEstudiosQr =
  (requestBody, idPariente, nextStep) => (dispatch) => {
    dispatch({
      type: ESTUDIOTURNOS_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .post(`his/estudios/turno/${idPariente ? idPariente : -1}`, requestBody)
        .then((res) => {
          dispatch({
            type: ESTUDIOTURNOS_SUCCESS,
            payload: res.data,
          });
          if (nextStep) nextStep(true, res.data);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? // Si err.response.data es un objeto con 'detail', extraerlo
                typeof err?.response?.data === "object" &&
                err?.response?.data.detail
                ? err?.response?.data.detail
                : // Si es un objeto con 'title', usar title también
                  typeof err?.response?.data === "object" &&
                    err?.response?.data.title
                  ? err?.response?.data.title
                  : // Si es un objeto con 'mensaje', usar mensaje
                    typeof err?.response?.data === "object" &&
                      err?.response?.data.mensaje
                    ? err?.response?.data.mensaje
                    : // Si es un string, usarlo directamente
                      typeof err?.response?.data === "string"
                      ? err?.response?.data
                      : "Error al contactar el server."
              : "Error al contactar el server.",
          };

          dispatch({
            type: ESTUDIOTURNOS_ERROR,
            payload: error,
          });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const setCircuitoReso = (circuitoReso) => (dispatch) => {
  dispatch({
    type: ESTUDIOTURNOS_SETCIRCUITORESO,
    payload: circuitoReso,
  });
};
export const setCircuitoTomo = (circuitoTomo) => (dispatch) => {
  dispatch({
    type: ESTUDIOTURNOS_SETCIRCUITOTOMO,
    payload: circuitoTomo,
  });
};

export const wsPostCalulaMinutos = (requestBody, nextStep) => (dispatch) => {
  dispatch({ type: ESTUDIOTURNOS_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`his/estudios/calcular_minutos`, requestBody)
      .then((resp) => {
        dispatch({
          type: ESTUDIOTURNOS_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: ESTUDIOTURNOS_ERROR, payload: err?.data });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const logoutEstudiosTurnos = () => (dispatch) => {
  dispatch({ type: ESTUDIOTURNOS_LOGOUT });
};
